function Tag() {
    "use strict";

    this.__type = 'Tag:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.Description = '';
    this.IsActive = true;
    this.Latitude = 0.00;
    this.Longitude = 0.00;
    this.Name = '';
    this.Radius = 80.0;
    this.UserId = -1;    
}
if (typeof exports !== 'undefined') {
    module.exports = Tag;
}